<template>
  <div>
    <b-row>
      <b-col sm="12">
        <b-overlay :show="searchIsRunning" rounded="sm">
          <b-card>
            <h3 class="chr-h3">
              <b-icon icon="camera"></b-icon> Excursii
            </h3>
            <SearchForm
                :params="model.params"
                @search="runSearch"
                />
          </b-card>
        </b-overlay>
        <template v-if="!searchIsRunning">
          <b-card class="bg-light p-2 mt-3" no-body="" v-if="model.results.length">
            <b-row>
              <b-col sm="7" class="pt-1">
                <span class="mr-3 mt-3">RESULTS: </span>
                <translate :translate-n="noResults" translate-plural="%{noResults} results found">%{noResults} result found</translate>
              </b-col>
              <b-col sm="5">
                <SortFields
                  @sort="onSort"
                  @priceFilter="onPaginate"
                  />
              </b-col>
            </b-row>
          </b-card>

          <template v-if="model.results.length">
            <div class="content mt-3">
            <div v-for="(result, resultIndex) in filteredResults"  :key="resultIndex">
              <Result
                :result="result"
                :key="resultIndex"
                :selected="isSelected(result)"
                :expanded="resultIndex === 0"
                @priceDetails="onPriceDetails({ result })"
                @book="onBook({ ...$event, result })"
                @info="onInfo([result])"
                @toggle="onToggle(result)"
                />
            </div>
          </div>
          </template>
        </template>
      </b-col>
    </b-row>
    <SelectedResults
      :results="selectedResults"
      v-show="selectedResults.length"
      @hide="onHideSelected()"
      @info="onInfoSelected()"
      />
    <b-modal v-model="priceDetailsModal" :title="$gettext('Price Details')" size="lg" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
    <b-modal v-model="bookModal" :title="$gettext('Book Transfer')" size="xl" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closeBookModal" />
      <BookForm
        :result="bookInfo.result"
        :params="bookInfo.params"
        @closeModal="closeBookModal"
        @book="onBookingMade"
      />
    </b-modal>
    <b-modal v-model="modal" :title="$gettext('Modal Info')" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <!-- <SearchParamsSummary :params="model.params"/> -->
        <b-row v-for="(result, resultIndex) in infoResults" :key="'selected' + resultIndex" class="p-4">
          <Result
              :result="result"
              :expanded="true"
              :showBook="false"
              :showWebDescriptions="true"
              />
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>
  </div>
</template>

<script>
import model from './services/model'
import viewMixin from '../shared/mixins/search_views'

import SimpleModalHeader from '../shared/components/simple_modal_header'
import ModalFooter from '../shared/components/modal_footer'
import ModalHeader from '@/app/private/shared/components/modal_header'
import SearchForm from './components/search_form'
import BookForm from './components/book_form'
import Result from './components/result'
import PriceDetails from '@/app/private/shared/components/price_details'
import SelectedResults from '@/app/private/shared/components/selected_results'
import SortFields from './components/sort_fields'
// import SortFields from '@/app/private/shared/components/sort_fields'
// import SearchResultsSummary from './components/search_results_summary'
export default {
  components: { SimpleModalHeader, ModalFooter, ModalHeader, PriceDetails, SearchForm, Result, BookForm, SelectedResults, SortFields },
  mixins: [viewMixin],
  data () {
    return {
      model,
      priceDetailsParams: {
        meal: null,
        title: ''
      },
      priceDetailsModal: false,
      bookInfo: {
        result: null,
        params: model.params,
        date: null
      },
      modal: false,
      bookModal: false
    }
  },
  methods: {
    onPriceDetails ({ result }) {
      this.priceDetailsParams.title = result.label
      this.priceDetailsParams.meal = {
        price: result.gross,
        commission: result.commission,
        tax: result.tax
      }
      this.priceDetailsModal = true
    },
    onBook ({ result, date }) {
      this.bookInfo.result = result
      this.bookInfo.date = date
      this.bookModal = true
    },
    closePriceDetailsModal () { this.priceDetailsModal = false },
    closeBookModal () { this.bookModal = false },
    runSearch (params) {
      const myParams = { ...params }
      myParams.product_type = 51
      this.searchIsRunning = true
      model.search(myParams)
        .finally(() => { this.searchIsRunning = false })
    },
    onBookingMade (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  },
  computed: {
    noResults () { return this.model.results.length }
  }
}
</script>

<style lang="scss">
  .results-no{
    font-weight: 700;
    font-size: 1.1rem;
  }
</style>
